<template>
  <div>
    <template v-if="showHeader == true">
      <h3>{{ $t("advanced.headers." + unitName) }} {{ unitIndex }}</h3>
    </template>

    <v-simple-table :dense="true" :fixed-header="true">
      <template v-slot:default>
        <thead></thead>
        <tbody>
          <template v-if="filter.includes('Temps') === true">
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '1:'" icon="mdi-thermometer" :value="unitState.temperature1" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '2:'" icon="mdi-thermometer" :value="unitState.temperature2" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '3:'" icon="mdi-thermometer" :value="unitState.temperature3" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '4:'" icon="mdi-thermometer" :value="unitState.temperature4" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '5:'" icon="mdi-thermometer" :value="unitState.temperature5" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '6:'" icon="mdi-thermometer" :value="unitState.temperature6" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '7:'" icon="mdi-thermometer" :value="unitState.temperature7" unit="°C" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.temperature') + ' ' + '8:'" icon="mdi-thermometer" :value="unitState.temperature8" unit="°C" :widthRatio="75"></AdvancedCore>

            <template v-if="'temperatures' in unitState">
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '1:'" icon="mdi-thermometer" :value="unitState.temperatures.t1" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '2:'" icon="mdi-thermometer" :value="unitState.temperatures.t2" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '3:'" icon="mdi-thermometer" :value="unitState.temperatures.t3" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '4:'" icon="mdi-thermometer" :value="unitState.temperatures.t4" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '5:'" icon="mdi-thermometer" :value="unitState.temperatures.t5" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '6:'" icon="mdi-thermometer" :value="unitState.temperatures.t6" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '7:'" icon="mdi-thermometer" :value="unitState.temperatures.t7" unit="°C" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.temperature') + ' ' + '8:'" icon="mdi-thermometer" :value="unitState.temperatures.t8" unit="°C" :widthRatio="75"></AdvancedCore>
            </template>
          </template>

          <template v-if="filter.includes('Fans') === true">
            <AdvancedCore :name="$t('advanced.fanRequest') + ' ' + '1:'" :icon="unitState.fan1Request != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fan1Request" unit="%" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.fanFeedback') + ' ' + '1:'" :icon="unitState.fan1Feedback != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fan1Feedback" unit="%" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.fanRequest') + ' ' + '2:'" :icon="unitState.fan2Request != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fan2Request" unit="%" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.fanFeedback') + ' ' + '2:'" :icon="unitState.fan2Feedback != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fan2Feedback" unit="%" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.fanRequest') + ' ' + '3:'" :icon="unitState.fan3Request != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fan3Request" unit="%" :widthRatio="75"></AdvancedCore>
            <AdvancedCore :name="$t('advanced.fanFeedback') + ' ' + '3:'" :icon="unitState.fan3Feedback != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fan3Feedback" unit="%" :widthRatio="75"></AdvancedCore>

            <template v-if="'fans' in unitState">
              <AdvancedCore :name="$t('advanced.fanRequest') + ' ' + '1:'" :icon="unitState.fans.f1Request != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fans.f1Request" unit="%" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.fanFeedback') + ' ' + '1:'" :icon="unitState.fans.f1Feedback != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fans.f1Feedback" unit="%" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.fanRequest') + ' ' + '2:'" :icon="unitState.fans.f2Request != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fans.f2Request" unit="%" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.fanFeedback') + ' ' + '2:'" :icon="unitState.fans.f2Feedback != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fans.f2Feedback" unit="%" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.fanRequest') + ' ' + '3:'" :icon="unitState.fans.f3Request != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fans.f3Request" unit="%" :widthRatio="75"></AdvancedCore>
              <AdvancedCore :name="$t('advanced.fanFeedback') + ' ' + '3:'" :icon="unitState.fans.f3Feedback != 0 ? 'mdi-fan mdi-spin' : 'mdi-fan'" :value="unitState.fans.f3Feedback" unit="%" :widthRatio="75"></AdvancedCore>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import AdvancedCore from "./AdvancedCore.vue";

export default {
  name: "AdvancedTempsAndFans",
  components: {
    AdvancedCore,
  },
  props: {
    unitState: {
      type: Object,
      require: false,
    },
    unitIndex: {
      type: Number,
      require: true,
    },
    unitName: {
      type: String,
      require: true,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    filter: {
      type: Array,
      required: false,
      default: () => ["Temp", "Fans"],
    },
  },
};
</script>
